<div class="question-type-survey-descriptive-wrapper">
  <div class="form-group">
    <p class="para" [innerHtml]="this.html"></p>
  </div>
</div>
